import type { MouseEvent } from 'react';
import { useT } from '@/lib/i18n';

/**
 * First focusable element on every page. Moves focus to `<main id="main">` (a plain `#main` hash
 * would be intercepted by the router); without JavaScript the `href` still works natively.
 */
export function SkipLink() {
  const t = useT();

  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    const main = document.getElementById('main');
    if (!main) return;
    event.preventDefault();
    main.focus();
    main.scrollIntoView();
  };

  return (
    <a href="#main" className="skip-link" onClick={onClick}>
      {t('nav.skipToContent')}
    </a>
  );
}
